module.exports = __webpack_public_path__ + "static/media/ico-cm-inactive.eb8b7529.svg";